import Cookie from "js-cookie";

export function setCookie(name: string, value: string, expiry: number) {
  Cookie.set(name, value, { expires: expiry });
}

export function getCookie(name: string) {
  return Cookie.get(name);
}

export function getSessionId(): string | undefined {
  if (typeof window === "undefined") return undefined;
  return window.__inito__?.identity_manager?.session_id || getCookie("SessionId");
}

export const analtyicIds = {
  google_analytics: {
    us: "UA-77172961-5",
    default: "UA-77172961-1",
  },
  pixel: {
    us: "2257601964558507",
    default: "1028108590656222",
  },
};
